// * Icons
// material ui icons
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded';

const EnergyGroupTypeIcon = ({ type }) => {
  const baseEnergyKey = (type || 'Power').replace(/^Portfolio/, '');
  const paletteKey = baseEnergyKey.toLowerCase();

  const EnergyIcon =
    baseEnergyKey === 'Power'
      ? BoltRoundedIcon
      : baseEnergyKey === 'Heat'
        ? LocalFireDepartmentRoundedIcon
        : baseEnergyKey === 'Water'
          ? WaterDropRoundedIcon
          : baseEnergyKey === 'Buildings'
            ? ApartmentRoundedIcon
            : null;

  return (
    <EnergyIcon
      sx={(theme) => ({
        color: theme.palette[paletteKey]?.main || theme.palette.primary.main,
      })}
    />
  );
};

export default EnergyGroupTypeIcon;
